(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('ContentController', ContentController);

    /* @ngInject */
    function ContentController($rootScope, $scope, $state, $mdDialog, $q, Content, Folder, ParseLinks, AlertService, ContentAction, pagingParams, paginationConstants, $mdToast, $stateParams, $filter, CONTENT_META, $translate, Feature, ToastService, MetaData, PermissionService) {
        var vm = this;
        var OOTB_COLUMN_VALUE_PATHS = {
            content_no: function (content) { return content.content_no; },
            version: function (content) {
                return content.version != null && content.version !== '' ? content.version : 1;
            },
            last_modified_on: function (content) { return content.last_modified_on; },
            last_modified_by: function (content) { return content.last_modified_by; }
        };

        vm.loadAll = loadAll;
        vm.loadingData = false;
        vm.selectMenu = selectMenu;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate =
            !pagingParams.ascending && pagingParams.predicate
                ? "-" + pagingParams.predicate
                : pagingParams.predicate;
        vm.transition = transition;
        vm.reOrder = reOrder;
        vm.showFolders = true;
        vm.currentSelectedCards = [];
        vm.showBulkAssignAction = false;
        vm.showBulkSendAction = false;
        vm.updateContentListListener = null;
        vm.illustartionEmptyScreenId = "content";
        vm.illustartionEmptyScreenText = "There are no contents yet";
        vm.extendedFieldsEnabled = Feature.isActive('feature_content_extended_fields');
        vm.visibleColumns = [];
        vm.getContentColumnValue = getContentColumnValue;
        vm.hasVersioningAccess = PermissionService.hasAccess('versioning-content');
        vm.expandedContentId = null;
        vm.expandedVersions = {};
        vm.expandedVersionsLoading = {};

        if (vm.extendedFieldsEnabled) {
            loadVisibleColumns();
        }
        vm.defaultFolder = {
            id: "default",
            name: "Default",
            description: "Default"
        };

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-created_on',
            page: 1,
            filters: {
                folder: vm.defaultFolder,
                metaType: 'all',
                status: null,
            }
        };

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        vm.removeFilter = removeFilter;
        vm.filter.show = false;
        vm.deleteObject = deleteObject;
        vm.archiveObject = archiveObject;
        vm.editObject = editObject;
        vm.createObject = createObject;
        vm.getQueryString = getQueryString;

        vm.permissions = {
            create: 'create-content',
            update: 'update-content',
            delete: 'delete-content',
            manage: 'manage-content',
            createFolder: 'manage-folder-content',
            updateFolder: 'manage-folder-content',
            deleteFolder: 'manage-folder-content',
            manageFolder: 'manage-folder-content',
            manageTopic: 'manage-topic-content',
            manageBadge: 'manage-badge-system'
        };

        vm.createMenu = true;
        vm.createMenuOptions = $filter('filter')($filter('orderBy')(CONTENT_META, 'display_order'), {
            category: 'main',
            dispay_in_options: true,
            type: '!session-recording'
        });

        //vm.createMenuOptions = $filter('filter')($filter('orderBy')(vm.createMenuOptions, 'display_order'), {
        //    type: '!session-recording'
        //});

        vm.launchContentPreview = function(content) {
            ContentAction.previewContent(content);
        };

        vm.openBulkEditDialog = function() {
            if (vm.currentSelectedCards.length > 0) {
                $mdDialog.show({
                    templateUrl: 'modules/content/content-bulk-edit-dialog.tmpl.html',
                    clickOutsideToClose: true,
                    controller: "ContentBulkEditController",
                    controllerAs: "vm",
                    size: 'lg',
                    locals: {
                        contents: vm.currentSelectedCards
                    }
                }).then(function(result) {
                    vm.currentSelectedCards = [];
                });
            }
        }

        vm.openBulkAssignDialog = function() {
            if (vm.currentSelectedCards.length > 0) {
                var currentSelectedCardsIds = [];
                angular.forEach(vm.currentSelectedCards, function(currentSelectedCard) {
                    currentSelectedCardsIds.push(currentSelectedCard.id)
                })
                ContentAction.openAssignModal(currentSelectedCardsIds, false, false, function() {
                    vm.currentSelectedCards = [];
                });
            }
        }

        vm.openBulkAssignRemoveDialog = function() {
            if (vm.currentSelectedCards.length > 0) {
                var currentSelectedCardsIds = [];
                angular.forEach(vm.currentSelectedCards, function(currentSelectedCard) {
                    currentSelectedCardsIds.push(currentSelectedCard.id)
                })
                ContentAction.openAssignModal(currentSelectedCardsIds, false, true, function() {
                    vm.currentSelectedCards = [];
                });
            }
        }

        vm.getMediaUrl = function(mediaUrl) {
            return $filter('mediaUrl')(mediaUrl);
        }

        vm.getCardProperty = function(type) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: type.replace(/_/g, '-')
            })[0];
            return contentMetaData.card_properties;
        }

        vm.getDefaultBackground = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultBackground : '';
        }

        vm.getDefaultIcon = function(type) {
            var card_properties = vm.getCardProperty(type);
            return card_properties != undefined ? card_properties.defaultIcon : '';
        }

        vm.convertTypeForBackend = function(type) {
            return type.replace(/-/g, '_')
        }

        vm.copyContent = function(contentId, contentType) {
            $state.go("storm.admin-content-detail", {
                'contentType': contentType.replace(/-/g, '_'),
                'id': contentId,
                'copy': true
            });
        };

        vm.getPredicate = function () {
            if (vm.predicate.startsWith("-")) {
                if (
                    vm.predicate.endsWith(",desc") ||
                    vm.predicate.endsWith(",asc")
                ) {
                    return vm.predicate.substr(1);
                }
                return vm.predicate.substr(1) + ",desc";
            } else {
                if (
                    vm.predicate.endsWith(",desc") ||
                    vm.predicate.endsWith(",asc")
                ) {
                    return vm.predicate;
                } else {
                    return vm.predicate + ",asc";
                }
            }
        };

        function loadAll() {
            vm.loadingData = true;
            var savedQuery = getSavedFilters();
            if ( savedQuery ) {
                vm.query = savedQuery;
            }
            vm.page = vm.query.page;
            Content.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.getPredicate(),
                query: getQueryString(),
                is_web: true,
                is_not_filter: true
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contents = data;
                resetExpandedVersions();
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        }

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        }

        function transition() {
            vm.promise = Content.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: vm.getPredicate(),
                query: getQueryString(),
                is_web: true,
                is_not_filter: true
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.contents = data;
                resetExpandedVersions();
            });
            vm.query.page = vm.page;
            saveFilters(vm.query);
            vm.query.sort = vm.predicate;
        }

        function getQueryString() {
            var contentQuery = 'embedded==false;type=out=(SMART_CONTENT,EMAIL_LAYOUT);status!=ARCHIVED;';
            var metaTypeStr = vm.query.filters.metaType == 'all' ? '' : ';' + vm.query.filters.metaType;

            contentQuery = contentQuery + 'meta_type!=INFO_CARD' + metaTypeStr;

            if (vm.query.filters.topicId) {
                contentQuery = contentQuery + ';topics=in=' + vm.query.filters.topicId;
            }

            if (vm.query.filters.disabled) {
                contentQuery = contentQuery + ';enabled==false';
            }

            if (vm.query.filter.length > 0) {
                var qs = vm.query.filter;
                var reEscapedStr = String(qs).replace(/([.*+?=^!:${}()|[\]\/\\])/g, '\\$1');
                var reAndQuoteEscapedStr = String(reEscapedStr).replace(/([\\"])/g, '\\$1');
                var quoteEscapedStr = String(qs).replace(/([\\"])/g, '\\$1');
                contentQuery = contentQuery + ';(title=re="' + reAndQuoteEscapedStr + '",description=re="' + quoteEscapedStr + '",tags=re="' + quoteEscapedStr + '")';
            }
            return contentQuery;
        }

        function removeFilter() {
            vm.filter.show = false;
            vm.query.filter = '';
            resetModal();
        }

        function createObject() {
            $state.go("storm.admin-applet-detail");
        }

        function editObject(contentId, contentType) {
            $state.go("storm.admin-content-detail", {
                'contentType': contentType.replace(/-/g, '_'),
                'id': contentId
            });
        }

        function archiveObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.content.archiveObject'))
                .ariaLabel($filter('translate')('atheer.content.archiveObject'))
                .ok($filter('translate')('entity.action.archive'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                entity.status = 'ARCHIVED';

                Content.update(entity, function() {
                    resetModal();
                });
            });
        };

        function deleteObject(entity) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.content.deleteObject'))
                .ariaLabel($filter('translate')('atheer.content.deleteObject'))
                .ok($filter('translate')('entity.action.delete'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Content.delete({
                    id: entity.id
                }, function() {
                    resetModal();
                });
            });
        };

        function resetModal() {
            loadAll();
            AlertService.displayToast($mdToast);
        };

        vm.openAddFolderModal = function(contentObj) {
            $mdDialog.show({
                templateUrl: 'modules/content/content-folder-dialog.tmpl.html',
                clickOutsideToClose: true,
                controller: "ContentFolderController",
                controllerAs: "vm",
                size: 'lg',
                locals: {
                    content: contentObj
                }
            }).then(function() {
                vm.loadAll();
            });
        }

        vm.removeContentFolder = function(contentObj) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('atheer.content.removeContentFolder') + vm.selectedFolder.name + '?')
                .ariaLabel($filter('translate')('atheer.content.deleteContentFolder'))
                .ok($filter('translate')('entity.action.remove'))
                .cancel($filter('translate')('entity.action.cancel'));

            $mdDialog.show(confirm).then(function() {
                Folder.delete({
                    id: folder.id
                }, function() {
                    ToastService.displayToast($filter('triTranslate')('atheer.content.removedSuccessfully'), 3000);
                });
            });
        }

        vm.updateParentObject = function() {
            $mdDialog.hide(vm.currentSelectedCards);
        }

        vm.getCardMeta = function(card) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: card.data.type.replace(/_/g, '-')
            })[0];
            return contentMetaData;
        };

        vm.showCopyAction = function(card) {
            return vm.getCardMeta(card).show_copy_action;
        };

        vm.allowInsights = function(card) {
            var contentMetaData = $filter('filter')(CONTENT_META, {
                type: card.data.type.replace(/_/g, '-')
            })[0];
            return contentMetaData.enable_insights;
        };

        vm.toggleFilter = function() {
            vm.filter.show = !vm.filter.show;
            if (vm.filter.show) {
                vm.showFolders = false;
            }
        };

        vm.clearSelection = function() {
            vm.currentSelectedCards = [];
        };

        vm.seeInsights = function(contentId, contentType) {
            $state.go("storm.admin-content-detail-insights.section", {
                'contentType': contentType,
                'id': contentId,
                'section': 'overview'
            });
        };

        function selectMenu(item) {
            $state.go('storm.admin-content-detail', {
                'contentType': item.type.replace(/-/g, '_')
            });
        }

        function saveFilters(filterData) {
            sessionStorage.setItem('objectFilters', JSON.stringify(filterData));
        };
    
        function getSavedFilters() {
            return JSON.parse(sessionStorage.getItem('objectFilters'));
        };

        function loadVisibleColumns() {
            MetaData.get({
                id: 'content',
                is_name: true,
                add_default_properties: true
            }, function (meta) {
                vm.visibleColumns = deriveVisibleColumns(meta);
            });
        }

        function deriveVisibleColumns(meta) {
            var columns = [];
            if (!meta || !meta.field_groups) {
                return columns;
            }
            angular.forEach(meta.field_groups, function (group) {
                angular.forEach(group.fields || [], function (field) {
                    if (field.column_visible && field.name !== 'title') {
                        columns.push(field);
                    }
                });
            });
            return columns;
        }

        vm.isVersionNumberColumnVisible = function () {
            var visible = false;
            angular.forEach(vm.visibleColumns, function (field) {
                if (field && field.name === 'version') {
                    visible = true;
                }
            });
            return visible;
        };

        vm.isDocumentContent = function (content) {
            return !!(content && content.data && String(content.data.type || '').toUpperCase() === 'DOCUMENT');
        };

        vm.hasContentVersioning = function (content) {
            if (!content || !vm.isDocumentContent(content)) {
                return false;
            }
            if (vm.expandedVersions[content.id] !== undefined) {
                return vm.expandedVersions[content.id].length > 0;
            }
            if (angular.isArray(content.versioning)) {
                return content.versioning.filter(function (version) {
                    return version && version.content_id && version.content_id !== content.id;
                }).length > 0;
            }
            return content.version != null && content.version > 1;
        };

        vm.canShowContentVersioning = function (content) {
            return vm.extendedFieldsEnabled &&
                vm.isVersionNumberColumnVisible() &&
                vm.hasVersioningAccess &&
                vm.hasContentVersioning(content);
        };

        // Title + dynamic columns + Created On + actions; the checkbox cell is added by md-row.
        vm.getVersionExpandColspan = function () {
            return (vm.visibleColumns || []).length + 3;
        };

        vm.isVersionHistoryLoading = function (content) {
            return !!(content && vm.expandedVersionsLoading[content.id]);
        };

        vm.toggleContentVersionHistory = function (content, event) {
            if (event) {
                event.stopPropagation();
            }
            if (!content || !vm.extendedFieldsEnabled || !vm.hasVersioningAccess) {
                return;
            }
            if (vm.expandedContentId === content.id) {
                vm.expandedContentId = null;
                return;
            }
            if (!vm.isVersionNumberColumnVisible() || !vm.hasContentVersioning(content)) {
                return;
            }
            vm.expandedContentId = content.id;
            if (vm.expandedVersions[content.id] === undefined && !vm.expandedVersionsLoading[content.id]) {
                loadContentVersions(content);
            }
        };

        function mergeContentDetailIntoVersion(versionRow, detail) {
            if (!detail) {
                return versionRow;
            }
            return {
                id: versionRow.content_id,
                content_id: versionRow.content_id,
                title: detail.title || versionRow.title,
                version: detail.version != null ? detail.version : versionRow.version,
                status: detail.status || versionRow.status,
                created_on: detail.created_on || versionRow.created_on,
                last_modified_on: detail.last_modified_on || versionRow.last_modified_on,
                last_modified_by: detail.last_modified_by || versionRow.last_modified_by,
                content_no: detail.content_no != null ? detail.content_no : versionRow.content_no,
                custom_attributes: detail.custom_attributes || versionRow.custom_attributes || {},
                data: detail.data || versionRow.data
            };
        }

        function enrichVersionsWithContentDetails(versionRows) {
            var requests = (versionRows || []).map(function (versionRow) {
                return Content.get({ id: versionRow.content_id }).$promise.then(
                    function (detail) {
                        return mergeContentDetailIntoVersion(versionRow, detail);
                    },
                    function () {
                        return versionRow;
                    }
                );
            });
            return $q.all(requests);
        }

        function finishVersionHistoryLoad(content, versionRows) {
            if (!versionRows || !versionRows.length) {
                delete vm.expandedVersions[content.id];
                if (vm.expandedContentId === content.id) {
                    vm.expandedContentId = null;
                }
            } else {
                vm.expandedVersions[content.id] = versionRows;
            }
            vm.expandedVersionsLoading[content.id] = false;
        }

        function loadContentVersions(content) {
            var familyId = content.family_id || content.id;
            vm.expandedVersionsLoading[content.id] = true;
            Content.getVersions({ id: familyId, exclude_archived: true }, function (versions) {
                var versioningByContentId = {};
                angular.forEach(content.versioning || [], function (versionMeta) {
                    if (versionMeta && versionMeta.content_id) {
                        versioningByContentId[versionMeta.content_id] = versionMeta;
                    }
                });

                var otherVersions = (versions || []).filter(function (version) {
                    var versionContentId = version.content_id || version.contentId || version.id;
                    return versionContentId && versionContentId !== content.id;
                }).map(function (version) {
                    var versionContentId = version.content_id || version.contentId || version.id;
                    var versionMeta = versioningByContentId[versionContentId] || {};
                    return {
                        id: versionContentId,
                        content_id: versionContentId,
                        title: version.title || versionMeta.title,
                        version: version.version != null ? version.version : versionMeta.version,
                        status: version.status || versionMeta.status,
                        created_on:
                            version.created_on ||
                            version.createdOn ||
                            version.updated_on ||
                            version.updatedOn ||
                            versionMeta.updated_on ||
                            versionMeta.created_on,
                        last_modified_on: version.last_modified_on || version.lastModifiedOn,
                        last_modified_by: version.last_modified_by || version.lastModifiedBy,
                        content_no: version.content_no || version.contentNo,
                        custom_attributes: version.custom_attributes || version.customAttributes || {},
                        data: version.data || content.data
                    };
                }).sort(function (a, b) {
                    return (Number(b.version) || 0) - (Number(a.version) || 0);
                });

                if (!otherVersions.length) {
                    finishVersionHistoryLoad(content, []);
                    return;
                }

                enrichVersionsWithContentDetails(otherVersions).then(function (enrichedVersions) {
                    if (vm.expandedContentId !== content.id) {
                        vm.expandedVersionsLoading[content.id] = false;
                        return;
                    }
                    finishVersionHistoryLoad(content, enrichedVersions);
                });
            }, function () {
                vm.expandedVersionsLoading[content.id] = false;
                if (vm.expandedContentId === content.id) {
                    vm.expandedContentId = null;
                }
            });
        }

        vm.openVersionContent = function (version) {
            if (!version || !version.content_id) {
                return;
            }
            var contentType = (version.data && version.data.type) ? version.data.type : 'document';
            $state.go('storm.admin-content-detail', {
                contentType: String(contentType).replace(/-/g, '_'),
                id: version.content_id
            });
        };

        function resetExpandedVersions() {
            vm.expandedContentId = null;
            vm.expandedVersions = {};
            vm.expandedVersionsLoading = {};
        }

        function getRawContentColumnValue(content, field) {
            if (!content || !field || !field.name) {
                return undefined;
            }
            if (OOTB_COLUMN_VALUE_PATHS[field.name]) {
                return OOTB_COLUMN_VALUE_PATHS[field.name](content);
            }
            if (content.custom_attributes && Object.prototype.hasOwnProperty.call(content.custom_attributes, field.name)) {
                return content.custom_attributes[field.name];
            }
            return undefined;
        }

        function getListValueLabel(field, value) {
            if (!field.list_options || value === undefined || value === null || value === '') {
                return '';
            }
            var matched = $filter('filter')(field.list_options, {
                'option_id': value
            }, true)[0];
            return matched ? matched.label : value;
        }

        function getContentColumnValue(content, field) {
            var value = getRawContentColumnValue(content, field);
            if (value === undefined || value === null || value === '') {
                return '';
            }
            if (field.data_type === 'LIST') {
                return getListValueLabel(field, value);
            }
            if (field.data_type === 'DATE' || field.data_type === 'DATE_TIME') {
                return moment(value).format(field.data_type === 'DATE_TIME' ? 'MM/DD/YYYY HH:mm' : 'MM/DD/YYYY');
            }
            return value;
        }

        $scope.$watchCollection('vm.currentSelectedCards', function(newVal) {
            vm.showBulkAssignAction = false;
            vm.showBulkSendAction = false;

            angular.forEach(newVal, function(content) {
                if (content.data.type == 'email_template') {
                    vm.showBulkSendAction = true;
                } else {
                    vm.showBulkAssignAction = true;
                }
            });

            $scope.$emit('refreshSelectedCardsToolbar', vm.currentSelectedCards);
        });

        var refreshContentListener = $rootScope.$on('refreshContent', function(event, filter) {
            vm.query.filter = filter;
            vm.query.page = 1;
            saveFilters(vm.query);
            vm.query.sort = vm.predicate;
            vm.loadAll();
        });

        //calls when hit menu on sidebar to open sub menus in side bar
        var updateContentListListener = $rootScope.$on('updateContentList', function(event, filters) {
            vm.illustartionEmptyScreenId = "no_content";
            vm.query.filters = filters;
            vm.query.page = 1;
            saveFilters(vm.query);
            vm.loadAll();
        });

        var refreshSelectedCardsListing = $rootScope.$on('refreshSelectedCardsListing', function(event, currentSelectedCards) {
            vm.currentSelectedCards = currentSelectedCards;
        });

        // Unregister
        $scope.$on('$destroy', function() {
            updateContentListListener();
            refreshContentListener();
            refreshSelectedCardsListing();
        });

        vm.loadAll();
    }
})();
